import { Inject, Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { first } from 'rxjs/internal/operators/first';
import { NavigationExtras } from '@angular/router';

@Injectable()
export class VerifyAuthService implements CanActivate {


    constructor(private router: Router,
                private afAuth: AngularFireAuth ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const data = route.data;
        const params = route.params;
        let id = route.params['idTutor'];
        console.log('encontro id'+ id);
        if (params?.from === 'login' || id) {
            return Promise.resolve(true);
        }

        const navigationExtras: NavigationExtras = {
            queryParams: {invalidUser: true},
        };
        return this.afAuth.authState.pipe(first())
        .toPromise()
            .then(auth => {
                if (!auth) {
                    this.router.navigate(['/', ], navigationExtras);
                    return false;
                } else {
                    return true;
                }
            }).catch(error => {
                console.log('el guard es ', false);
                this.router.navigate(['/'], navigationExtras);
                return Promise.resolve(false);
            });
    }

}
